import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { Countdown } from './Countdown';
import { trackInitiateCheckout } from '../lib/pixel';
const included = ['6 tomos digitales con protocolos claros y aplicables', '6 bonos prácticos para los momentos que más dudas generan', '400+ páginas para consultar a tu ritmo', 'Material 100% digital y adaptado al contexto argentino'];
export function PricingSection() {
  return <section id="pricing" className="bg-brand-darker px-4 py-16 md:py-20" data-id="element-223" data-mp="1s9n4rsfvfezk">
      <div className="mx-auto max-w-3xl" data-id="element-224" data-mp="1sbq7nd24h2lp">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-225" data-mp="1x86wk9h5bkzu">
          <p className="text-sm font-bold tracking-[0.14em] text-brand-accent uppercase" data-id="element-226" data-mp="2uyvw16hof6a">Una sola decisión, todo el acompañamiento</p>
          <h2 className="mt-3 font-serif text-4xl text-brand-cream-light md:text-5xl" data-id="element-227" data-mp="7ul7y7akzpdi">Elegí tu pack S.O.S. Lactancia</h2>
          <p className="mt-4 text-lg text-brand-cream/75" data-id="element-228" data-mp="1mhzgt6bke99c">6 tomos + 6 bonos para vivir tu lactancia con más información y calma.</p>
        </motion.div>

        <div className="my-9 text-center" data-id="element-229" data-mp="1cqbx5rl91wif">
          <p className="mb-5 font-bold text-brand-cream" data-id="element-230" data-mp="1cr4uy328dbof">⏰ PRECIO DE LANZAMIENTO — CIERRA EN:</p>
          <Countdown data-id="element-231" data-mp="17td133i0zfhl" />
        </div>

        <motion.article initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="rounded-3xl border-2 border-brand-accent bg-brand-cream-light p-7 shadow-2xl md:p-10" data-id="element-232" data-mp="25fir0d9rdxxc">
          <div className="text-center" data-id="element-233" data-mp="1vfjlkp8mynop">
            <span className="inline-flex rounded-full bg-brand-accent/25 px-4 py-1.5 text-xs font-bold tracking-[0.12em] text-brand-darker uppercase" data-id="element-234" data-mp="1rg1ael6m9qz2">
              Pack completo
            </span>
            <h3 className="mt-4 font-serif text-4xl text-brand-darker" data-id="element-235" data-mp="g0ug6ggtgo1f">🍼 S.O.S. Lactancia</h3>
            <p className="mt-2 text-lg text-brand-darker/70" data-id="element-236" data-mp="hi193tdbhqfn">El pack de 6 tomos + 6 bonos</p>
          </div>

          <ul className="mx-auto mt-8 max-w-xl space-y-4" data-id="element-237" data-mp="mhe79a9n2jxj">
            {included.map(item => <li key={item} className="flex items-start gap-3 text-brand-darker/80" data-id="element-238" data-mp="7k3mfab3w1p5">
                <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-darker" aria-hidden="true" data-id="element-239" data-mp="cioq5jpkh3ic" />
                <span data-id="element-240" data-mp="3uwxt3o7zd02k">{item}</span>
              </li>)}
          </ul>

          <div className="mt-9 border-t border-brand-primary/25 pt-7 text-center" data-id="element-241" data-mp="3i07uct54gzn">
            <p className="text-xl text-brand-darker/45 line-through" data-id="element-242" data-mp="3k395szqtwjo">$89.000 ARS</p>
            <p className="mt-1 font-serif text-5xl font-bold text-brand-darker md:text-6xl" data-id="element-243" data-mp="3l0bdpeyfb17x">$19.990 <span className="text-2xl" data-id="element-244" data-mp="3py33o3ficd9h">ARS</span></p>
            <p className="mt-2 text-sm text-brand-darker/65" data-id="element-245" data-mp="3by24qtiszfwn">Precio de lanzamiento · Descarga digital inmediata</p>
          </div>

          <a href="https://www.mamasincaos.store/cart/45320272543767:1" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout({
          value: 19990,
          currency: 'ARS',
          contentName: 'S.O.S. Lactancia Pack',
          contentIds: ['45320272543767']
        })} className="mt-8 flex min-h-[58px] w-full items-center justify-center rounded-2xl bg-brand-accent px-6 py-4 text-center text-lg font-bold text-brand-darker shadow-lg transition-all hover:scale-[1.02] hover:bg-[#f0aea2]" data-id="element-246" data-mp="3fyc8s0n1bw8v">
            ✨ QUIERO MI PACK S.O.S. LACTANCIA ✨
          </a>
        </motion.article>
      </div>
    </section>;
}